module.exports = __webpack_public_path__ + "img/Lab_Book_Icon_Up.0575ab00.svg";